module.exports = __webpack_public_path__ + "img/filters.a19a439b.svg";